var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"text-left",attrs:{"offset-md":"2"}},[_c('img',{staticClass:"headerImg",attrs:{"src":require("../assets/headerLogo.png")}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }